const form = () => {
  var elsaPackages = [
    'one_month_credit',
    'three_months_credit',
    'six_months_credit',
    'one_year_credit',
    'two_years_credit',
    'lifetime_membership',
    'oxford_starter',
    'oxford_elementary',
    'oxford_pre_intermediate',
    'oxford_intermediate',
    'oxford_upper_intermediate',
    'oxford_advanced',
    'oxford_all_books',
    'one_month_credit_premium',
    'three_months_credit_premium',
    'one_year_credit_premium',
    'lifetime_membership_premium',
    'one_month_credit_nova_premium',
    'three_months_credit_bundle_elsa_pre_pro',
    'one_year_credit_bundle_elsa_pre_pro',
    'lifetime_membership_bundle_elsa_pre_pro',
  ];

  const isMembershipExist = (packages, membership) => {
    var result = false;
    if (Array.isArray(membership) && membership.length > 0) {
      for(let i = 0; i < membership.length; i++) {
        if (packages.includes(membership[i])) {
          result = true;
        } else {
          result = false;
          break;
        }
      }
    } else {
      result = false;
    }
    return result;
  };

  const buildMembership = (arrayPackages) => {
    var membershipString = '';
    if (arrayPackages.length < 1) return;
    if (arrayPackages.length === 1) {
      membershipString = arrayPackages[0];
    } else {
      arrayPackages.map((item, index) => {
        if (index === arrayPackages.length - 1) {
          membershipString += `1 x ${item}`;
        } else {
          membershipString += `1 x ${item} and `;
        }
      });
    }
    return membershipString;
  };

  const buildMembershipObj = (arrayPackages) => {
    var membershipObj = {};
    if (arrayPackages.length < 1) return;
    arrayPackages.map(item => {
      membershipObj[item] = 1;
    });
    return membershipObj;
  };

  const insertLeadsDropped = function(data, callback) {
    $.ajax({
      url: '/wp-admin/admin-ajax.php',
      type: 'POST',
      data: {
        action: 'affiliate_insert_leads',
        post_data: data
      },
      success: function() {
        callback();
      }
    });
  };

  const $packageItemSelect = $('.js-select-package');
  $('.list-packages').each(function () {
    const currentMembershipItem = $(this).closest('.section-register').find('input[name="membership"]:checked').attr("id");

    $(this).find('label[for="' + currentMembershipItem + '"]').addClass('is-active');
    $(this).find(`p.${currentMembershipItem}-promotion`).addClass('is-show');
  });

  $packageItemSelect.on('click', function () {
    if (!$(this).hasClass('is-active')) {
      $(this).closest('.list-packages').find($packageItemSelect).removeClass('is-active');
      $(this).stop().addClass('is-active');
      $(this).closest('.list-packages').find('p.discount-code').removeClass('is-show');
      $(this).closest('.list-packages').find('p.' + $(this).attr('for') + '-promotion').addClass('is-show');
    }
  });

  // single checked
  $('.elsa-oxford input[type="checkbox"]').on('change', function() {
    if ($(this).val() === 'oxford_all_books') {
      $('.elsa-oxford input[type="checkbox"]').not(this).prop('checked', false);
    } else {
      $(".elsa-oxford input[value='oxford_all_books']").not(this).prop('checked', false);
    }
  });

  $('form.form-register').each(function () {
    const form = $(this);
    const submitForm = function () {
      form[0].submit();
    };

    const getUtmSource = function (utm) {
      const urlString = window.location.href;
      const url = new URL(urlString);
      const utmSource = url.searchParams.get(utm);
      return utmSource || '';
    };

    form.on('submit', function (e) {
      e.preventDefault();
      const affiliate_id = $('input[name="affiliate_id"]').val();
      const click_id = getUtmSource('click_id');
      let totalAmount = 0;

      let errorMessage = '';
      let phone = form.find('input[name="phone"]').val();
      const name = form.find('input[name="fullname"]').val();
      const email = form.find('input[name="email"]').val();
      var listPrices = [];
      var checkedBoxes = [];
      var hasError = false;

      if (form.find('input[name="membership"]').attr("type") === 'hidden') {
        var membership = form.find('input[name="membership_name"]:checked').val();
        form.find('input[name="membership_name"]:checked').map(function() {
          checkedBoxes.push($(this).val());
          listPrices.push($(this).data('price'));
        });
        totalAmount = listPrices.reduce(function (partialSum, price) {
          return partialSum + price;
        }, 0);

        if (isMembershipExist(elsaPackages, checkedBoxes)) {
          var membershipString = buildMembership(checkedBoxes);
          $('input[name="membership"]').val(membershipString);
        } else {
          hasError = true;
          if($('input[name="membership_name"]:checked').length > 0) {
            alert('Paket tidak valid');
          }
        };
      } else {
        var membership = form.find('input[name="membership"]:checked').val();
      }

      if (!isPhoneValid(phone)) {
        errorMessage += '<p>- Por favor digite seu número com DDD no formato +55xx9xxxxxxxx ou xx9xxxxxxxx</p>'
      }
      if (!name) {
        errorMessage += '<p>- Por favor, preencha as informações completas</p>'
      }
      if (!validateEmail(email)) {
        errorMessage += '<p>- Por favor, insira um formato de e-mail válido</p>'
      }
      if (!membership) {
        errorMessage += '<p>- Por favor, selecione um pacote.</p>'
      }
      if (errorMessage) {
        e.preventDefault();
        form.find('.js-form-errors').html(errorMessage).show();
        const offset = form.find('.js-form-errors').offset().top + form.find('.js-form-errors').innerHeight() - $(window).height() + 3;
        $('html, body').animate({
          scrollTop: offset
        }, 800)
        return;
      }
      form.find('.js-form-errors').html('').hide();

      if (phone[0] === '0') {
        phone = phone.replace('0', '+62');
      }

      if (!hasError) {
        submitForm();
      }
    });
  });

  $('input[name="search"]').val(location.search);

  function validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  function isPhoneValid(phone) {
    if (typeof phone !== 'string' || phone.trim() === '') {
      return false;
    }

    // This regular expression checks for the following patterns:
    // 1. Optional: Starts with "+55" (country code), possibly followed by a space.
    // 2. Mandatory: A 2-digit area code.
    // 3. Optional: A space after the area code.
    // 4. Mandatory: A 9-digit phone number that MUST start with '9'.
    // It anchors the match to the beginning (^) and end ($) of the string.
    const brazilianPhoneRegex = /^(\+55\s?)?(\d{2})\s?(9\d{8})$/;

    return brazilianPhoneRegex.test(phone);
  }
};

export default form;
